import { BASE_URL } from "../common/constants";
import axios from "axios";
import { withTokenCheck } from "./userAxiosServices"
import { ExamType, QuestionType, SchoolTestType, StartExamRequestType } from "../common/school-tests";

const createSchoolTest = async (test: SchoolTestType) => {
	const body = {
		name: test.name,
		description: test.description,
		excellent_score_value: test.excellentScoreValue,
		very_good_score_value: test.veryGoodScoreValue,
		good_score_value: test.goodScoreValue,
		satisfy_score_value: test.satisfyScoreValue,
		fail_score_value: test.failScoreValue,
		// questions: test.questions.map((q) => ({
		// 	question_text: q.text,
		// 	answer_a: q.answers[0] || "",
		// 	answer_b: q.answers[1] || "",
		// 	answer_c: q.answers[2] || "",
		// 	answer_d: q.answers[3] || "",
		// 	correct_answer: q.correctAnswer, // expects "A", "B", "C", or "D"
		// 	score_value: q.scoreValue,
		// })),
	};
	const response = axios.post(BASE_URL + `exam/test-teachers/`, body, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const createSchoolTestService = withTokenCheck(createSchoolTest)


const editSchoolTest = async (test: SchoolTestType) => {
	const body = {
		name: test.name,
		description: test.description,
		excellent_score_value: test.excellentScoreValue,
		very_good_score_value: test.veryGoodScoreValue,
		good_score_value: test.goodScoreValue,
		satisfy_score_value: test.satisfyScoreValue,
		fail_score_value: test.failScoreValue,
		// questions: test.questions.map((q) => ({
		// 	question_text: q.text,
		// 	answer_a: q.answers[0] || "",
		// 	answer_b: q.answers[1] || "",
		// 	answer_c: q.answers[2] || "",
		// 	answer_d: q.answers[3] || "",
		// 	correct_answer: q.correctAnswer, // expects "A", "B", "C", or "D"
		// 	score_value: q.scoreValue,
		// })),
	};
	const response = axios.put(BASE_URL + `exam/test-teachers/${test.id}/`, body, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const editSchoolTestService = withTokenCheck(editSchoolTest)

const deleteSchoolTest = async (schoolTestId: string) => {
	const response = axios.delete(BASE_URL + `exam/test-teachers/${schoolTestId}/`, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const deleteSchoolTestService = withTokenCheck(deleteSchoolTest)

const createSchoolTestQuestion = async (question: QuestionType) => {
	const body = {
		question_text: question.text,
		answer_a: question.answers[0] || "",
		answer_b: question.answers[1] || "",
		answer_c: question.answers[2] || "",
		answer_d: question.answers[3] || "",
		correct_answer: question.correctAnswer,
		score_value: question.scoreValue,
		test: question.schoolTestId,
	};

	const response = await axios.post(BASE_URL + `exam/test-teachers-questions/`, body, {
		headers: { Authorization: `JWT ${localStorage.getItem("access")}` },
	});

	return response.data;
}
export const createSchoolTestQuestionService = withTokenCheck(createSchoolTestQuestion);

// ---------------- EDIT QUESTION ----------------
const editQuestion = async (question: QuestionType) => {
	const body = {
		question_text: question.text,
		answer_a: question.answers[0] || "",
		answer_b: question.answers[1] || "",
		answer_c: question.answers[2] || "",
		answer_d: question.answers[3] || "",
		correct_answer: question.correctAnswer,
		score_value: question.scoreValue,
	};

	const response = await axios.put(BASE_URL + `exam/test-teachers-questions/${question.id}/`, body, {
		headers: { Authorization: `JWT ${localStorage.getItem("access")}` },
	});

	return response.data;
};
export const editQuestionService = withTokenCheck(editQuestion);

// ---------------- DELETE QUESTION ----------------
const deleteQuestion = async (id: string) => {
	const response = await axios.delete(BASE_URL + `exam/test-teachers-questions/${id}/`, {
		headers: { Authorization: `JWT ${localStorage.getItem("access")}` },
	});
	return response.data;
};
export const deleteQuestionService = withTokenCheck(deleteQuestion);

const getMySchoolTest = async (
	userId: string,
	currentPage: number,
	sortBy: 'alphabet' | 'date' = 'date', // Default to sorting by date
	sortOrder: 'asc' | 'desc' = 'desc',   // Default to descending order
) => {
	const response = axios.get(BASE_URL + `exam/test-teachers/`, {
		params: {
			user_id: userId,
			page: currentPage,
			sort_by: sortBy,
			sort_order: sortOrder,
		},
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const getMySchoolTestService = withTokenCheck(getMySchoolTest)

const getMySchoolTestList = async (
	userId: string,
) => {
	const response = axios.get(BASE_URL + `exam/test-teachers-list/`, {
		params: {
			created_by: userId,
		},
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const getMySchoolTestListService = withTokenCheck(getMySchoolTestList)

const getSchoolTestById = async (schoolTestId: string) => {
	const response = axios.get(BASE_URL + `exam/test-teachers/${schoolTestId}/`, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}
export const getSchoolTestByIdService = withTokenCheck(getSchoolTestById)

const getSchoolExamById = async (schoolExamId: string) => {
	const response = axios.get(BASE_URL + `exam/exams/${schoolExamId}/`, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}
export const getSchoolExamByIdService = withTokenCheck(getSchoolExamById)

const createSchoolExam = async (exam: ExamType) => {
	const body = {
		school_test: exam.schoolTestId,
		student: exam.studentsIds,
		teacher: exam.teacherId,
		start_at: exam.startExamAt,
		end_at: exam.endExamAt
	};
	const response = axios.post(BASE_URL + `exam/exams/`, body, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const createSchoolExamService = withTokenCheck(createSchoolExam)

const searchUsers = async (search: string) => {
	const response = axios.get(BASE_URL + 'exam/users-search/', {
		params: { search: search },
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const searchUsersService = withTokenCheck(searchUsers)

const getMyExams = async (
	userId: string,
	currentPage: number,
	sortBy: 'alphabet' | 'date' = 'date', // Default to sorting by date
	sortOrder: 'asc' | 'desc' = 'desc',   // Default to descending order
	testId?: string | null
) => {
	const params: Record<string, any> = {
		user_id: userId,
		page: currentPage,
		sort_by: sortBy,
		sort_order: sortOrder,
	};
	// ✅ only add test_id if testId is provided
  if (testId) {
    params.test_id = testId;
  }
	const response = await axios.get(BASE_URL + `exam/exams/`, {
    params,
    headers: {
      Authorization: `JWT ${localStorage.getItem("access")}`,
    },
  });

  return response;
}
export const getMyExamsService = withTokenCheck(getMyExams)

const schoolExamStarted = async (examId: string) => {
	const response = axios.put(BASE_URL + `exam/exam-started/${examId}/`, {}, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}
export const schoolExamStartedService = withTokenCheck(schoolExamStarted)


const schoolExamAnswer = async ({
	examId,
	questionId,
	studentAnswer
}: StartExamRequestType) => {
	const body = {
		student_answer: studentAnswer
	}
	const response = await axios.post(
		`${BASE_URL}exam/${examId}/${questionId}/answer/`,
		body,
		{
			headers: {
				Authorization: `JWT ${localStorage.getItem("access")}`,
			},
		}
	);
	return response.data;
};

export const schoolExamAnswerService = withTokenCheck(schoolExamAnswer);


const schoolExamDetails = async (examId: string) => {
	const response = axios.get(BASE_URL + `exam/exams/${examId}/`, {
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}
export const schoolExamDetailsService = withTokenCheck(schoolExamDetails)


const getMyStudentsExams = async (
	userId: string,
	currentPage: number,
	sortBy: 'alphabet' | 'date' = 'date', // Default to sorting by date
	sortOrder: 'asc' | 'desc' = 'desc',   // Default to descending order
) => {
	const response = axios.get(BASE_URL + `exam/students-exams/`, {
		params: {
			user_id: userId,
			page: currentPage,
			sort_by: sortBy,
			sort_order: sortOrder,
		},
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}
export const getMyStudentsExamsService = withTokenCheck(getMyStudentsExams)